import React from 'react';
import PropTypes from 'prop-types';
import './Message.css';

export default function Message({ message, showMessage }) {
    // the word is not in the list, the message will fade out
    if (message === 'Not in the word list') {
        return (
            <div className="message-container">
                <div className="message-not-in-list" style={{ display: showMessage ? 'block' : 'none' }}>
                    {message}
                </div>
            </div>
        );
    }

    // win or lose (game over)
    return (
        <div className="message-container">
            <div className="message-game-over" style={{ display: showMessage ? 'block' : 'none' }}>
                {message}
            </div>
        </div>
    );
}

Message.defaultProps = {
    message: '',
    showMessage: false,
};

Message.propTypes = {
    message: PropTypes.string,
    showMessage: PropTypes.bool,
};
